import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { TransferLearnerState } from "./transfer-learner.state";
import { Userprofile } from "src/app/_models/Userprofile";
import { HttpErrorResponse } from "@angular/common/http";
import { AssignedOrganisation } from "src/app/_models/Organisation";
import { SubmitTransferResponse } from "src/app/_models/TransferLearner";

export const selectTransferLearnerState = createFeatureSelector<TransferLearnerState>(StoreConstants.STATE_TLS);

export const selectTransferLearnerLoader = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): boolean => state.loading
);

export const selectTransferLearnerCentreLoader = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): boolean => state.loadingTransferCentre
);

export const selectFindLearnerDetails = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): Userprofile => state.learnerDetails
);

export const selectFindLearnerError = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): HttpErrorResponse => state.learnerDetailsError
);

export const selectAssignedOrganisation = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): AssignedOrganisation[] => state.assignedOrganisation
);

export const selectAssignedOrganisationError = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): HttpErrorResponse => state.assignedOrganisationError
);

export const selectSubmitTransferRequest = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): SubmitTransferResponse => state.submitTransferResponse
);

export const selectSubmitTransferRequestError = createSelector(
  selectTransferLearnerState, 
  (state: TransferLearnerState): HttpErrorResponse => state.submitTransferError
);

export const selectStartTransferResult = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): boolean => state.transferResult
);

export const selectStartTransferError = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): HttpErrorResponse => state.transferError
);

export const selectUndoTranferResult = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): boolean => state.undoTransferResult
);

export const selectUndoTransferError = createSelector(
  selectTransferLearnerState,
  (state: TransferLearnerState): HttpErrorResponse => state.undoTransferError
);
